import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineFileDeleteApiOptions {
  disciplineId: string | number
  fileId: number
}

/** `DELETE /admin-api/disciplines/{discipline}/files/{file}` — removes an uploaded file of the draft. */
export const useDisciplineFileDeleteApi = async (options: DisciplineFileDeleteApiOptions): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.file', {
    discipline_id: options.disciplineId,
    file_id: options.fileId,
  })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.delete<ApiResponse>(url)
    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err) || 'Failed to delete file.')
    return false
  }
}
